
/* styles */
require("!!../../../node_modules/_extract-text-webpack-plugin@1.0.1@extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/_vue-loader@10.3.0@vue-loader/lib/style-rewriter?id=data-v-3767fdc8&scoped=true!../../../node_modules/_vue-loader@10.3.0@vue-loader/lib/selector?type=styles&index=0!./price_import.vue")

var Component = require("!../../../node_modules/_vue-loader@10.3.0@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/_vue-loader@10.3.0@vue-loader/lib/selector?type=script&index=0!./price_import.vue"),
  /* template */
  require("!!../../../node_modules/_vue-loader@10.3.0@vue-loader/lib/template-compiler?id=data-v-3767fdc8!../../../node_modules/_vue-loader@10.3.0@vue-loader/lib/selector?type=template&index=0!./price_import.vue"),
  /* scopeId */
  "data-v-3767fdc8",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/nav2/price_import.vue
// module id = 698
// module chunks = 2